module.exports = __webpack_public_path__ + "static/media/trenitalia.d460c705.svg";